// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
const VisibilityActions = {
  SET_HIDE_WHEN: 'SET_HIDE_WHEN',
  SET_RBAC_POLICIES: 'SET_RBAC_POLICIES',
  SET_V2_RBAC_POLICIES: 'SET_V2_RBAC_POLICIES',
  SET_IS_SUPPORT_ENGINEER: 'SET_IS_SUPPORT_ENGINEER',
  SET_V2_ROOT_WKSPC_POLICIES: 'SET_V2_ROOT_WKSPC_POLICIES',
  SET_V2_USER_GROUPS_POLICIES: 'SET_V2_USER_GROUPS_POLICIES'
}

export default VisibilityActions
